"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation generateUserProfileReport($query: UserProfileQueryInput) {
    generateUserProfileReport(query: $query) {
      url
      message
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=generateUserProfileReport.mutation.js.map